import { render, staticRenderFns } from "./VircosFinishing.vue?vue&type=template&id=ff89234a&scoped=true&"
import script from "./VircosFinishing.vue?vue&type=script&lang=js&"
export * from "./VircosFinishing.vue?vue&type=script&lang=js&"
import style0 from "./VircosFinishing.vue?vue&type=style&index=0&id=ff89234a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff89234a",
  null
  
)

export default component.exports